import * as ThemeUi from 'theme-ui';
import React from 'react';

export const Box = React.forwardRef<HTMLElement, ThemeUi.BoxProps>((props, ref) => {
  return <ThemeUi.Box {...props} ref={ref} />;
});
